import { UncheckedCheckboxIcon, CheckedCheckboxIcon } from '../../icons';

interface ICheckInputBaseProps {
  /**
   * A boolean indicating whether the checkbox is checked.
   */
  checked: boolean;
  /**
   * A callback function that will be executed when the checkbox is clicked.
   */
  onClick: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * It renders checkbox element in which it does show checked or unchecked icon
 * and it has a method to toggle the checked state.
 */
export function ContactCheckbox({
  checked,
  onClick,
}: Readonly<ICheckInputBaseProps>) {
  return (
    <button
      className="cursor-pointer border-none bg-transparent"
      onClick={onClick}
      type="button"
    >
      {checked ? <CheckedCheckboxIcon /> : <UncheckedCheckboxIcon />}
    </button>
  );
}
